<template>
  <div
    class="input-container"
    :class="{ uploaded_already: is_uploaded, mini: mini }"
  >
    <div v-if="is_uploaded && !newOne && !mini" style="color: white;">
      {{ $t("already uploaded") }} : "{{ is_uploaded.original_name }}"
      <hr class="horizontal-line" />
    </div>
    <div>
      <div style="color:white;">
        <slot />
      </div>
      <p v-if="isFileSizeError" class="error-message">
        {{ $t("maximum size 5mb") }}
      </p>
      <label :for="componentID" class="label button">{{
        documentName ||
          (is_uploaded ? $t("choose new file") : $t("choose file"))
      }}</label>
      <input
        @input="handleDocumentLoad"
        type="file"
        class="input"
        :id="componentID"
      />
    </div>
  </div>
</template>

<script>
import { getShortenedStringWithDots } from "@/helpers/string";

const MAX_FILE_SIZE = 5242880; // Максимальный размер файла по умолчанию равен 5Мб

export default {
  model: {
    prop: "file",
    event: "input"
  },
  props: {
    mini: {
      default: false,
      type: Boolean
    },
    is_uploaded: {
      default() {
        return false;
      },
      type: [Object, Boolean]
    },
    componentID: String
  },
  data() {
    return {
      newOne: false,
      documentName: "",
      isFileSizeError: false
    };
  },
  methods: {
    handleDocumentLoad(e) {
      let input = e.target;
      let file = input.files[0];
      if (!this.isFileSizeValid(file)) {
        this.showFileSizeErrorMessage();
        return;
      } else {
        this.hideFileSizeErrorMessage();
      }
      this.setFileNameLabel(file);
      // console.log(file);
      this.$emit("input", file);
      this.$emit("attached", file);
    },
    // Устанавливаем имя файла как текст поля загрузки файла
    setFileNameLabel(file) {
      let fileName = file.name;
      this.documentName = getShortenedStringWithDots(fileName, 14);
    },
    // Проверяем размер файла на валидность
    isFileSizeValid(file) {
      let fileSize = file.size;
      if (fileSize >= MAX_FILE_SIZE) {
        return false;
      }
      return true;
    },
    // Показываем сообщение о превышении допустимого размера файла
    showFileSizeErrorMessage() {
      this.isFileSizeError = true;
    },
    // Скрываем сообщение о превышении допустимого размера файла
    hideFileSizeErrorMessage() {
      this.isFileSizeError = false;
    }
  }
};
</script>

<style scoped>
.button {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  margin-top: 5px;
}
.input-container {
  margin-bottom: 15px;
  padding: 30px 40px;
  border: 1px dashed #ffffff;
  border-radius: 15px;
}
.input-container.mini {
  padding: 15px 10px 10px;
  font-size: 14px;
}

.input-container.uploaded_already {
  border-color: #2e79ef;
  background-color: rgba(0, 0, 0, 0.3);
}

.label {
  padding: 10px 5px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  border: 1px dashed #2e79ef;
  border-radius: 10px;
  cursor: pointer;
}

/* Скрываем полностью поле input'а файла. Input активируется при нажатии на label */
.input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.error-message {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  color: red;
}
</style>
